module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"loginexpired":"Your login has expired. Please login again."},"fi":{"loginexpired":"Sisäänkirjautumisesi on vanhentunut. Kirjauduthan uudestaan."}}')
  delete Component.options._Ctor
}
